var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8422",
    "data-name": "Path 8422",
    d: "M21.825,11.237H21.1V11.2H13v3.6h5.086a5.4,5.4,0,1,1-1.5-5.832l2.546-2.546A8.991,8.991,0,1,0,22,13,9.061,9.061,0,0,0,21.825,11.237Z",
    transform: "translate(-4 -4)",
    fill: "#ffc107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8423",
    "data-name": "Path 8423",
    d: "M6.306,8.811l2.957,2.169a5.389,5.389,0,0,1,8.588-2.012L20.4,6.422A8.982,8.982,0,0,0,6.306,8.811Z",
    transform: "translate(-5.268 -4)",
    fill: "#ff3d00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8424",
    "data-name": "Path 8424",
    d: "M14.207,35.23a8.958,8.958,0,0,0,6.034-2.336l-2.786-2.357A5.386,5.386,0,0,1,9.13,28.054L6.2,30.315A8.993,8.993,0,0,0,14.207,35.23Z",
    transform: "translate(-5.207 -17.23)",
    fill: "#4caf50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8425",
    "data-name": "Path 8425",
    d: "M32.825,20.037H32.1V20H24v3.6h5.086a5.418,5.418,0,0,1-1.839,2.507h0l2.785,2.357A8.706,8.706,0,0,0,33,21.8,9.061,9.061,0,0,0,32.825,20.037Z",
    transform: "translate(-15 -12.8)",
    fill: "#1976d2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.404c26e2e15052631d60c208e3eafdfc.svg";
export { ForwardRef as ReactComponent };